import * as Sentry from '@sentry/react';
import toast from 'react-hot-toast';
import { localAnalytics } from './analytics';
import { i18n } from '../localization/i18n';

export const logErrorsWithMessage = (error: any, message: string) => {
  logErrorsWithoutAlert(error, message);

  if (error?.message) {
    toast.error(`${i18n.t('error')}: ${error.message}`);
  } else {
    toast.error(`${i18n.t('error')}: ${message}`);
  }
};

export const logErrorsWithoutAlert = (error: any, message: string) => {
  console.error(`[Error] ${message}`, error);

  Sentry.captureException(error, {
    tags: {
      errorMessage: message,
    },
    extra: {
      message,
      errorDetails: error,
    },
  });

  localAnalytics().logEvent('ErrorTracking', {
    errorType: error?.name || 'UnknownError',
    message: error?.message || message,
    stack: error?.stack,
  });
};
